export default __webpack_public_path__ + "images/4e08285764891aab5f452feb2d17ba7d.png";